<template>
  <PartnersList
    :config="config"
    :custom-query="{
      role: 2,
      includepartners: false,
    }"
  />
</template>

<script>
import PartnersList from './PartnersList.vue'

import storeModule from '../companyStoreModule'

export default {
  components: {
    PartnersList,
  },
  computed: {
    config() {
      return {
        store: storeModule,
        module: 'companies',
        endpoint: 'companies',
        route: 'companies',
        filtersOpen: true,
        title: {
          single: this.$i18n.t('Supplier'),
          plural: this.$i18n.t('Suppliers'),
        },
      }
    },
  },
}
</script>
